import React, { useEffect, useRef, useState } from "react";
import "../dashboard.scss";
import { academylist } from "../../../services/admin";
import { roleList, stuclasslist, studivisionlist } from "../../../services/master";
import Select from "react-select";
import { roleuserlist, smslist, smstemplatelist } from "../../../services/common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function Sendsms() {
    const navigate = useNavigate();
    const [aclist, setACList] = useState([]);
    const [acaid, setAcaID] = useState("");
    const [academyName, setAcademyName] = useState("");
    const [arole, setARole] = useState("");
    const [rlist, setRList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [acls, setACls] = useState([]);
    const [asec, setASec] = useState([]);
    const [tempid, setTempId] = useState("");
    const [message, setMessage] = useState("");
    const [variables, setVariables] = useState([]);
    const [audioBlob, setAudioBlob] = useState(null);

    const [emplist, setEmpList] = useState([]);
    const [empid, setEmpId] = useState([]);
    const [loading, setLoading] = useState(false);

    const [tlist, setTList] = useState([]);

    useEffect(() => {
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setACList(arr);
                }
            }
        });

        roleList().then((res) => {
            if (res.status === true) {
                let arr = [{ value: 0, label: "All" }];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].name,
                        });
                    }
                    setRList(arr);
                }
            }
        });

        stuclasslist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].class_name,
                        });
                    }
                    setClassList(arr);
                }
            }
        });

        studivisionlist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].name,
                        });
                    }
                    setSectionList(arr);
                }
            }
        });

        smstemplatelist().then((res) => {
            if (res.status === true) {
                const sdata = res.data.map((item) => ({
                    id: item.id,
                    Temp: item.temp_id,
                    Name: item.temp_name,
                    Message: item.temp_message,
                    Content: item.temp_content,
                    temp_sample: item.temp_sample,
                }));
                setTList(sdata);
            }
        });

        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    const selectedAca = res.data.details.find(
                        (a) => a.id == localStorage.getItem("AAcademy")
                    );
                    setAcademyName(selectedAca.name);
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name +
                                        " - " +
                                        res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);

                            }
                        }
                    }
                }
            });
        }
    }, []);

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
        } else {
            setAcaID("");
        }
    }
    function handleRole(e) {
        setEmpList([]);
        if (e !== null) {
            // const edata = e.some((item) => item.value === 0);
            // if (edata) {
            //     setARole({ value: 0, label: "All" });
            // } else {
            //     setARole(e);
            // }
            if (e.value === 0) {
                setARole({ value: 0, label: "All" });
            } else {
                setARole(e);
            }

            if (e.value > 4) {
                roleuserlist(e.value, localStorage.getItem("AAcademy")).then((res) => {
                    if (res.status) {
                        const sdata = res.data.map((item) => ({
                            value: item.id,
                            label: e.value == 5 ? `${item.teacher_name} - ${item.username}` : `${item.worker_name} - ${item.username}`,
                        }));
                        setEmpList(sdata);
                    }
                });
            }
        } else {
            setARole("");
        }
    }

    function handleClass(e) {
        if (e !== null) {
            setACls(e);
        } else {
            setACls([]);
        }
    }


    function handleSection(e) {
        if (e !== null) {
            setASec(e);
        } else {
            setASec([]);
        }
    }

    function handleName(e) {
        if (e !== null) {
            setEmpId(e);
        } else {
            setEmpId([]);
        }
    }

    const [recording, setRecording] = useState(false);
    const [audioURL, setAudioURL] = useState(null);
    const [recordTime, setRecordTime] = useState(0);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const timerIntervalRef = useRef(null);

    const handleStartRecording = async () => {
        if (recording) return;
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            const options = { mimeType: "audio/webm;codecs=opus" };
            let mediaRecorder;
            if (MediaRecorder.isTypeSupported(options.mimeType)) {
                mediaRecorder = new MediaRecorder(stream, options);
            } else {
                mediaRecorder = new MediaRecorder(stream);
            }

            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];
            setRecordTime(0);

            mediaRecorder.ondataavailable = (e) => {
                if (e.data.size > 0) audioChunksRef.current.push(e.data);
            };

            mediaRecorder.onstop = () => {
                if (audioURL) {
                    URL.revokeObjectURL(audioURL);
                }
                const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
                setAudioBlob(audioBlob);
                const url = URL.createObjectURL(audioBlob);
                setAudioURL(url);
                clearInterval(timerIntervalRef.current);
                setRecordTime(0);
            };

            mediaRecorder.start();
            setRecording(true);

            // Start timer counting seconds
            timerIntervalRef.current = setInterval(() => {
                setRecordTime((t) => t + 1);
            }, 1000);
        } catch {
            alert("Microphone access denied or not available");
        }
    };

    const handleStopRecording = () => {
        if (!recording) return;
        mediaRecorderRef.current.stop();
        setRecording(false);
    };

    const clearRecording = () => {
        if (audioURL) {
            URL.revokeObjectURL(audioURL);
        }
        setAudioURL(null);
        audioChunksRef.current = [];
    };

    useEffect(() => {
        return () => {
            if (audioURL) {
                URL.revokeObjectURL(audioURL);
            }
            clearInterval(timerIntervalRef.current);
        };
    }, [audioURL]);

    const formatTime = (time) => {
        if (!time || isNaN(time)) return "00:00";
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };


    const [sTemplate, setSTemplate] = useState(null);
    const [varCount, setVarCount] = useState(0);

    // const handleTemplateChange = (e) => {
    //     const selectedId = e.target.value;
    //     setTempId(selectedId);

    //     const selectedTemplate = tlist.find((item) => item.id.toString() === selectedId);
    //     if (!selectedTemplate) return;
    //     if (selectedTemplate) {
    //         let msg = selectedTemplate.Message;
    //         setSTemplate(selectedTemplate.Content);
    //         if (academyName) {
    //             msg = msg.replaceAll("- {#var#}", academyName);
    //         }

    //         if (academyName) {
    //             msg = msg.replace("{#var#}", academyName);
    //         }

    //         const date = new Date().toLocaleDateString();
    //         msg = msg.replace("{#var#}", date);

    //         setMessage(msg);
    //         //This is how we have replace all the variables
    //         //             let msg = template.Message;
    //         // msg = msg.replace("{#var#}", academyName); // first placeholder
    //         // msg = msg.replace("{#var#}", date);        // second placeholder


    //         // // Count remaining variables if needed
    //         // const matches = msg.match(/{#var#}/g);
    //         // const count = matches ? matches.length : 0;
    //         // setVarCount(count);
    //         // console.log(count);
    //     } else {
    //         setMessage("");
    //     }
    // }
    const [tempsamp, setTempSamp] = useState("");
    const handleTemplateChange = (e) => {
        const selectedId = e.target.value;
        setTempId(selectedId);

        const selectedTemplate = tlist.find((t) => t.id.toString() === selectedId);
        if (!selectedTemplate) return;
        setTempSamp(selectedTemplate.temp_sample);
        const parts = selectedTemplate.Content.split(/{#var#}/g);
        const vars = parts.slice(0, -1).map(() => ""); // one less than parts
        setVariables(vars);

        // Initial message with placeholders
        let initialMsg = parts.reduce((acc, part, idx) => {
            if (idx < vars.length) {
                return acc + part + vars[idx];
            } else {
                return acc + part;
            }
        }, "");

        setMessage(initialMsg);
    };

    const handleVariableChange = (index, value) => {
        const newVars = [...variables];
        newVars[index] = value;
        setVariables(newVars);

        const selectedTemplate = tlist.find((t) => t.id.toString() === tempid);
        if (!selectedTemplate) return;

        const parts = selectedTemplate.Content.split(/{#var#}/g);
        const newMsg = parts.reduce((acc, part, idx) => {
            if (idx < newVars.length) {
                return acc + part + newVars[idx];
            } else {
                return acc + part;
            }
        }, "");
        setMessage(newMsg);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!arole) {
            toast.error("Select SMS For");
            return;
        }
        const tmp = tlist.find((t) => t.id.toString() === tempid);
        if (!tmp) {
            toast.error("Select Template");
            return;
        }

        const classIds = acls?.map((item) => item.value).join(",") || "";
        const sectionIds = asec?.map((item) => item.value).join(",") || "";
        const empIds = empid?.map((item) => item.value).join(",") || "";
        const temp = new FormData();
        temp.append("template_id", tmp?.Temp || "");
        temp.append("academy_id", localStorage.getItem("AAcademy"));
        temp.append("role_id", arole.value);
        temp.append("class_id", classIds);
        temp.append("section", sectionIds);
        temp.append("emp_id", empIds);
        temp.append("message", message);
        temp.append("audio", "");
        temp.append("type", 'general');

        setLoading(true);
        smslist(temp).then((res) => {
            if (res.status === true) {
                setLoading(false);
                toast.success(res.message);
                // navigate("/communication/sendsms");
            }
        })
    };

    const handleAudioSubmit = (e) => {
        e.preventDefault();
        if (!arole) {
            toast.error("Select SMS For");
            return;
        }
        if (!audioBlob) {
            toast.error("Please Record an audio message");
            return;
        }

        const classIds = acls?.map((item) => item.value).join(",") || "";
        const sectionIds = asec?.map((item) => item.value).join(",") || "";
        const empIds = empid?.map((item) => item.value).join(",") || "";
        const temp = new FormData();
        temp.append("template_id","");
        temp.append("academy_id", localStorage.getItem("AAcademy"));
        temp.append("role_id", arole.value);
        temp.append("class_id", classIds);
        temp.append("section", sectionIds);
        temp.append("emp_id", empIds);
        temp.append("message", message);
        temp.append("audio", audioBlob, `recording.webm`);
        temp.append("type", 'audio');

        setLoading(true);
        smslist(temp).then((res) => {
            if (res.status === true) {
                setLoading(false);
                toast.success(res.message);
                navigate("/communication/smslist");
            }
        })
    };
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Add SMS</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Communication</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Add SMS
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <div className="container-fluid">
                        {/* SMS Section */}
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Add SMS</h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {localStorage.getItem("Role") === "1" && (
                                        <div className="col-xl-6 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Select Academy <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={aclist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />
                                            </div>
                                        </div>
                                    )}


                                    <div className="col-xl-6 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                SMS For <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select SMS For"
                                                value={arole}
                                                options={rlist}
                                                onChange={handleRole}
                                                isSearchable={true}
                                                // isMulti
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>


                                    {arole.value == "4" && (
                                        <>
                                            <div className="col-xl-6 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Class <span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Class"
                                                        value={acls}
                                                        options={classList}
                                                        onChange={handleClass}
                                                        isSearchable={true}
                                                        isMulti
                                                        isClearable
                                                        hidden
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-6 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Section <span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Section"
                                                        value={asec}
                                                        options={sectionList}
                                                        onChange={handleSection}
                                                        isSearchable={true}
                                                        isMulti
                                                        isClearable
                                                        hidden
                                                    />
                                                </div>
                                            </div>


                                        </>
                                    )}
                                    {arole.value > "4" && (
                                        <>
                                            <div className="col-xl-6 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Name <span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Name"
                                                        value={empid}
                                                        options={emplist}
                                                        onChange={handleName}
                                                        isSearchable={true}
                                                        isMulti
                                                        isClearable
                                                        hidden
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="col-xl-6 col-lg-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Template
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select  form-control wide"
                                                value={tempid}
                                                onChange={handleTemplateChange}
                                            >
                                                <option value="" disabled>
                                                    Select Template
                                                </option>
                                                {tlist.map((item) => (
                                                    <option value={item.id}>{item.Name}</option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                    {/* <div className="col-xl-6 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                SMS Template Content <span className="text-danger"> *</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={4}
                                                placeholder="Enter SMS Content "
                                                value={sTemplate}
                                                readOnly
                                            />
                                           

                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Message Preview<span className="text-danger"> *</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={4}
                                                placeholder="Message Preview"
                                                value={message}
                                                readOnly
                                            />
                                        </div>
                                    </div> */}
                                    {tempid &&
                                        <>
                                            <div className="col-xl-12 col-sm-12">
                                                <div className="mb-3">
                                                    <label className="form-label">SMS Template </label>
                                                    <div id="smsEditor" style={{ border: "1px solid #ccc", padding: "10px", borderRadius: "5px" }}>
                                                        {tlist.find((item) => item.id.toString() === tempid)?.Content.split(/{#var#}/g).map((part, index, arr) => (
                                                            <React.Fragment key={index}>
                                                                <span>{part}</span>
                                                                {index < arr.length - 1 && (
                                                                    <>
                                                                        <input
                                                                            type="text"
                                                                            value={variables[index]}
                                                                            onChange={(e) => handleVariableChange(index, e.target.value)}
                                                                            style={{
                                                                                border: "1px solid #ccc",
                                                                                padding: "1px 3px",
                                                                                margin: "0 2px",
                                                                                borderRadius: "3px",
                                                                                width: "200px",       // adjust width as needed
                                                                                height: "30px",      // adjust height as needed
                                                                                fontSize: "12px",    // smaller font
                                                                            }}
                                                                        // style={{ border: "1px solid #ccc", padding: "2px 5px", margin: "0 2px", borderRadius: "3px" }}
                                                                        />

                                                                    </>
                                                                )}
                                                            </React.Fragment>
                                                        ))}

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-12 col-sm-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Message Preview</label>
                                                    <div style={{ color: "red", fontSize: "12px" }}>
                                                        {tempsamp}
                                                    </div>
                                                    <textarea className="form-control" rows={4} value={message} readOnly />
                                                </div>
                                            </div>
                                        </>
                                    }

                                </div>

                                <div className="res-right mt-2 me-4">
                                    <button className="btn btn-success" onClick={handleSubmit}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>

                       

                    </div>
                </div>
            )}

        </div>
    );
}
